import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, fillPlaceholders } from '@skylab-shared/utils';

export type SendPaymentReminderResult = null;

//#region single
export interface SendSinglePaymentReminderParameters {
    recipients: string[];
    subjectPattern: string;
    messagePattern: string;
    attachDocument: boolean;
    ecoMode?: boolean;
    printingTemplateId?: number;
    senderName: string;
}

export class SendSinglePaymentReminderQuery extends Query<void> {
    public constructor(
        public readonly documentId: number
    ) {
        super();
    }
}

export class SendSinglePaymentReminderQueryHandlerBase implements QueryHandler<SendSinglePaymentReminderQuery, void> {
    private static Url = TaggedUrl.join('sales/unsettledDocuments/:id/email', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: SendSinglePaymentReminderQuery, params: SendSinglePaymentReminderParameters): Promise<void> {
        const url = fillPlaceholders(SendSinglePaymentReminderQueryHandlerBase.Url, { id: query.documentId });
        await this.http.post<SendPaymentReminderResult>(url, params, { timeout: MS_PER_MINUTE });
    }
}
//#endregion

//#region multi
export interface SendMultiPaymentReminderParameters {
    recipients: string[];
    subjectPattern: string;
    messagePattern: string;
    attachDocuments: boolean;
    ecoMode: boolean;
    senderName: string;
}

export class SendMultiPaymentReminderQuery extends Query<void> {
    public constructor(
        public readonly documentIds: number[]
    ) {
        super();
    }
}

export class SendMultiPaymentReminderQueryHandlerBase implements QueryHandler<SendMultiPaymentReminderQuery, void> {
    private static Url = TaggedUrl.join('sales/unsettledDocuments/batch/email', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: SendMultiPaymentReminderQuery, params: SendMultiPaymentReminderParameters): Promise<void> {
        await this.http.post<SendPaymentReminderResult>(SendMultiPaymentReminderQueryHandlerBase.Url, {
            ...params,
            ids: query.documentIds
        }, { timeout: MS_PER_MINUTE });
    }
}
//#endregion
